import React from 'react';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';
import {IElementLikertScale} from '../../../../incase-domain/elements/question/likertScale';
import LikertScaleQuestions from './LikertScaleQuestions';
import QuestionLayout from '../common/QuestionLayout';
import {IQuestionElementProps} from '../../../../incase-domain/elements/base/questionElementBase';
import LikertScaleQuestionsSlider from './LikertScaleQuestionsSlider';

function LikertScaleQuestionElement(props: IQuestionElementProps<IElementLikertScale>): JSX.Element {
    const {element, device = DeviceType.DESKTOP} = props;

    return (
        <QuestionLayout element={element} device={device} showConfirmButton>
            {element.sliderView ? (
                <LikertScaleQuestionsSlider element={element} device={device} />
            ) : (
                <LikertScaleQuestions element={element} device={device} />
            )}
        </QuestionLayout>
    );
}

export default LikertScaleQuestionElement;
